<template>
  <div class="bg-dark">
    <div v-if="!fileType && !base64" class="text-center">
      {{$t('filePreview.select')}}
    </div>
    <div v-else-if="fileType === 'image'">
      <v-img
        :src="base64"
        height="300"
        class="grey darken-4"
      ></v-img>
    </div>
    <div v-else-if="fileType === 'video'">
      <video
        :src="base64"
        controls
        style="width: 100%"
      ></video>
    </div>
    <div
      v-else-if="fileType === 'audio'"
      class="px-2"
    >
      <audio
        controls
        style="width: 100%; max-height: 300px"
      >
        <source :src="base64">
        {{$t('filePreview.audioNoSupport')}}
      </audio>
    </div>
    <div v-else class="text-center">
      <v-avatar color="primary">
        <Icon
          :width="24"
          :color="'rgba(0,0,0,.54)'"
          :icon="'file'"
        />
      </v-avatar>
    </div>
    <div
      v-if="validation.detail"
      class="pa-2"
    >
      <v-alert
        v-for="(error, index) in validation.detail.file"
        :key="`error-${index}`"
        dense
        outlined
        type="error"
        class="ma-0"
      >
        {{ error }}
      </v-alert>
    </div>
    <div class="d-flex align-center pa-2">
      <div>
        <v-btn
          fab
          small
          color="transparent"
          elevation="0"
          @click="clear"
          :disabled="uploading"
        >
          <Icon
            :width="24"
            :icon="'close'"
          />
        </v-btn>
      </div>
      <div class="caption px-2" :style="`max-width: ${elementWidth - 100}px`">
        <div class="d-flex align-top">
          <div class="mr-2 mt-1">
            <Icon
              :width="19"
              :height="19"
              :icon="'paperclip'"
            />
          </div>
          <div class="text-truncate">
            {{ file.name }}
            <div
              class="font-weight-bold"
              v-if="file && file.attachment"
              :class="bytesToKb(file.attachment.size) > 7024 ? 'text-danger' : 'text-success' "
            >
              {{ bytesToKb(file.attachment.size) }} KB
              <small v-if="bytesToKb(file.attachment.size) > 7024">
                {{$t('filePreview.limit')}}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-auto">
        <v-btn
          fab
          small
          color="transparent"
          elevation="0"
          @click="sendFile()"
          :loading="uploading"
          :disabled="uploading || bytesToKb(file.attachment.size) > 7024"
        >
          <Icon
            :width="24"
            :icon="'send'"
          />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'


require('@/plugins/FileUpload')

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    base64: {
      type: String,
      required: null
    },
    file: {
      type: Object,
      required: null
    }
  }
})
export default class FilePreview extends Vue {
  mounted () {
    this.elementWidth = this.$el.offsetWidth
    if (this.base64) {
      this.getFileType()
    }
  }

  data () {
    return {
      fileType: null,
      uploading: false,
      validation: {
        detail: null
      },
      elementWidth: 0
    }
  }

  bytesToKb (bytes) {
    if (!bytes) {
      return '0 KB'
    }
  
    return Number((bytes / 1024).toFixed(0))
  }

  setValidationErrors (error) {
    this.validation.detail = error
  }

  resetValidationErrors () {
    this.validation.detail = null
  }

  getFileType () {
    this.fileType = this.$fileUpload.fileType(this.base64)
  }

  clear () {
    this.$emit('clear')
  }

  sendFile () {
    this.uploading = true

    this.resetValidationErrors()

    this.$fileUpload.uploadSessionFile(this.file.attachment, this.$store.state.storage.room.session.id)
      .then((response) => {
        const res = response

        if (res.statusCode === 0) {
          this.$emit('clear')
          this.$parent.$parent.$parent.hide()

          const attachment = res.upload
          this.$emit('setAttachment', attachment)
        } else if (res.statusCode === 2) {
          this.$parent.$parent.$parent.show()
          this.setValidationErrors(res.detail)
        } else {
          console.log('error de servidor')
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .then(() => {
        this.uploading = false
      })
  }
}
</script>

<style>
.text-danger {
  color: rgb(221, 39, 39);
}

.text-success {
  color: rgb(33, 141, 33);
}
</style>
